import React, { Component } from "react";
import { getAuth } from "firebase/auth";

import "./Shared.css";
import "./Home.css";

import { getFavoriteBook, setFavoriteBook, clearFavoriteBook } from "./functions/books";

import Authenticated from "./Authenticated";
import SelectFavoriteBook from "./SelectFavoriteBook";
import AvailableBooks from "./AvailableBooks";
import TradeInProgress from "./TradeInProgress";

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {favoriteBookSelected: getFavoriteBook() !== null};
  }

  setBook = (book) => {
    setFavoriteBook(book);
    this.setState({favoriteBookSelected: true});
  }

  clearBook = () => {
    clearFavoriteBook();
    this.setState({favoriteBookSelected: false});
  }

  render() {
    return (
      <div className="Content Column">
        <div className="Column">

          <div className="TradeInProgressWrapper">
            <Authenticated silent={true} render={(user) => {
              return (
                <TradeInProgress user={user}>
                  <div className="Row Center">
                    <h3 className="Grow">Welcome back {user.displayName}!</h3>
                    <img className="SignOut" alt="Sign Out" src="/foreword/images/sign-out.png" onClick={() => getAuth().signOut()} />
                  </div>
                </TradeInProgress>
              )
            }} />

            <div className="Grow">
              <h1 className="HeaderText">Foreword</h1>

              {this.state.favoriteBookSelected ?
                <AvailableBooks clearBook={this.clearBook} /> :
                <div>
                  <SelectFavoriteBook setBook={this.setBook} clearBook={this.clearBook} />

                  <h2 className="TextCenter">Connect with someone new through your favorite book!</h2>

                  <h3 className="TextCenter">It’s like a “little library” turned into a book club</h3>

                  <div className="Row JustifyCenter">
                    <div className="Column HomeSteps">
                      <div className="Row HomeStep">
                        <img className="HomeStepImage" alt="Send a book" src="/foreword/images/step-one-sending.jpg" />
                        <div className="HomeStepContent">
                          <div className="StepNumber">1</div>
                          <div className="StepContent">Send in your favorite book. Include a handwritten note (a “foreword”) to its future owner about what the book means to you</div>
                        </div>
                      </div>
                      <div className="Row Margin HomeStep">
                        <img className="HomeStepImage" alt="Receive a book" src="/foreword/images/step-two-receiving.jpg" />
                        <div className="HomeStepContent">
                          <div className="StepNumber">2</div>
                          <div className="StepContent">Choose someone’s favorite book to read. Get it in the mail, and discover why it means so much to them!</div>
                        </div>
                      </div>
                      <div className="Row Margin HomeStep">
                        <img className="HomeStepImage" alt="Send a postcard" src="/foreword/images/step-three-postcard-send.jpg" />
                        <div className="HomeStepContent">
                          <div className="StepNumber">3</div>
                          <div className="StepContent">Once you’re finished reading their book, write them back on a pre-addressed postcard about how it impacted you</div>
                        </div>
                      </div>
                      <div className="Row Margin HomeStep">
                        <img className="HomeStepImage" alt="Receive a postcard" src="/foreword/images/step-four-postcard-receive.jpg" />
                        <div className="HomeStepContent">
                          <div className="StepNumber">4</div>
                          <div className="StepContent">When someone selects and finishes your book, you’ll hopefully receive a postcard in the mail too!</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }


            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;
